import styled from 'styled-components/macro'
import { theme } from 'styles/theme'

export const Content = styled.div`
  max-width: 70rem;
  margin: 0 auto;
  padding-top: calc(var(--container-spacing) / 2);
`

export const ShareMenu = styled.ul`
  margin: 0 -0.2em;
  padding: 0;
  list-style: none;
  font-size: 4rem;

  li {
    display: inline;
    padding: 0;
    margin: 0;
  }

  a {
    display: inline-block;
    width: 1em;
    height: 1em;
    margin: 0 0.2em;
    color: white;
    transition: all 0.3s;
    overflow: hidden;
    background: linear-gradient(
        to top,
        ${theme.colors.accent.primary} 50%,
        ${theme.colors.accent.secondary} 50%
      )
      50% 0/100% 200%;

    svg {
      display: block;
    }

    &:hover,
    &:focus {
      background-position: 50% 100%;
    }
  }
`
